import { type SpringValues } from '@react-spring/web';
import type { JSX } from 'react';
import { Avatar } from '@mentimeter/visualizations-react/components/identified-responses';
import type { BoxT } from '@mentimeter/ragnar-ui/box';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Text } from '@mentimeter/ragnar-ui/text';
import type { OpenEndedResponse } from '../types';

interface FocusedResponseProps extends BoxT {
  subheading: string;
  responseText: string;
  participantDisplayName: OpenEndedResponse['participantDisplayName'];
  UpvotesComponent: JSX.Element | null;
  Controls: JSX.Element | null;
  style: SpringValues;
}

export const FocusedResponse = ({
  subheading,
  responseText,
  participantDisplayName,
  UpvotesComponent,
  Controls,
  ...rest
}: FocusedResponseProps) => {
  return (
    <Box
      position="absolute"
      bg="neutralWeak"
      minWidth="50%"
      width="100%"
      maxWidth="1024px"
      p="space14"
      borderRadius="3xl"
      {...rest}
    >
      <Text fontSize="175" color="textWeaker">
        {subheading}
      </Text>
      <Text color="text" fontSize="250">
        {responseText}
      </Text>
      {participantDisplayName && (
        <Box flexDirection="row" py="space2" gap="space3" alignItems="center">
          <Avatar>{participantDisplayName.charAt(0).toUpperCase()}</Avatar>
          <Text
            fontSize="125"
            color="textWeak"
            style={{ wordBreak: 'break-word' }}
          >
            {participantDisplayName}
          </Text>
        </Box>
      )}
      <Box mt="auto" width="100%">
        {UpvotesComponent}
      </Box>
      <Box position="absolute" top="0" right="0" flexDirection="row" p="space4">
        {Controls}
      </Box>
    </Box>
  );
};
